import { useQuery } from 'react-query'
import Input from './Input'
import { useFormContext, useWatch } from 'react-hook-form'
import { api } from '../../../services/api'
import { useDebounce } from '../../../hooks/useDebounce'

export const NCM = () => {
  const { register, setValue } = useFormContext()

  const ncm = useWatch({ name: 'ncm' })

  const debouncedNcmValue = useDebounce(ncm, 500)

  const { data: cest, isLoading: cestLoading } = useQuery({
    queryKey: ['cest', ncm],
    queryFn: async () => {
      const response = await api.get(`/site/v2/produto/consulta-cest/${ncm}`)

      return response.data
    },

    onSuccess: (data) => {
      console.log('data', data)
      if (data?.cest !== '') {
        setValue('cest', data.cest)
      }
    },
    refetchOnWindowFocus: false,
    enabled: !!debouncedNcmValue && debouncedNcmValue !== '',
  })

  return <Input name="ncm" label="Ncm" placeholder="Ncm" type="number" maxW="175px" {...register('ncm')} />
}
